import { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { getAGGClient } from '@confluence/graphql';
import { useSessionData } from '@confluence/session-data';

import { UserCanPayAndUpgradeQuery } from '../../queries/UserCanPayAndUpgradeQuery.agggraphql';
import { HAMS_PRODUCT_KEY, OFFERING_KEY } from '../../experimentConstants';
import { PAY, useHandleHookStates } from '../useHandleHookStates';
import type { Entitlement } from '../../store/userInfoStore';
import { useUserInfoActions } from '../../store/userInfoStore';

type UserCanPayAndUpgradeQueryData = {
	tenantContexts?: {
		entitlementInfo?: {
			entitlement?: Entitlement;
		};
	}[];
};

export const useLoadUserCanPayAndUpgradeToStore = (skip: boolean) => {
	const { cloudId } = useSessionData();
	const { setEntitlement, setUserCanPayAndUpgrade } = useUserInfoActions();

	const { data, error, loading } = useQuery<UserCanPayAndUpgradeQueryData>(
		UserCanPayAndUpgradeQuery,
		{
			client: getAGGClient(),
			variables: {
				cloudId,
				productKey: HAMS_PRODUCT_KEY,
				offeringKey: OFFERING_KEY,
			},
			skip,
		},
	);

	useEffect(() => {
		if (!loading && !error && data) {
			const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
			void setEntitlement(entitlement);
			const userCanPayAndUpgrade =
				entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethod
					?.isAvailableToUser &&
				entitlement?.experienceCapabilities?.changeOffering?.isAvailableToUser;
			if (userCanPayAndUpgrade) {
				void setUserCanPayAndUpgrade(userCanPayAndUpgrade);
			}
		}
	}, [data, error, loading, setEntitlement, setUserCanPayAndUpgrade]);

	useHandleHookStates({ loading, error, hook: PAY });
};
